import {USER_SET} from '~/frontend/src/constants';
import {UserData} from '~/shared/src/model/User';

export type SetUserAction = {
    type : typeof USER_SET;
    userData : UserData;
}

/**
 * @memberOf! Actions
 *
 * @param {UserData} userData
 *
 * @return {SetUserAction}
 */
const setUser = ( userData : UserData ) : SetUserAction => {
    return {
        type: USER_SET,
        userData
    };
}

export type SetUser = typeof setUser;

export default setUser;
